import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';

@Component({
  selector: "app-refresh",
  templateUrl: "./refresh.component.html",
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RefreshComponent {
  @Output() refresh = new EventEmitter();

  constructor() { }
}